import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AssetGroupStore } from '../stores/asset-group.store';
import { AssetTypeStore } from '../stores/asset-type.store';
import { AssetStore } from '../stores/asset.store';

@Injectable({
  providedIn: 'root',
})
export class AssetGroupsResolver implements Resolve<void> {
  private readonly assetStore = inject(AssetStore);
  private readonly assetTypeStore = inject(AssetTypeStore);
  private readonly assetGroupStore = inject(AssetGroupStore);

  async resolve(): Promise<void> {
    await this.assetGroupStore.loadAll();
    await this.assetStore.loadAll();
    await this.assetTypeStore.loadAll();

    return Promise.resolve();
  }
}
